module.exports = __webpack_public_path__ + "img/foto.285f39aa.png";